import Colors, { withOpacity, } from '@polestar/component-warehouse-react/tokens/colors/Colors';
import Opacities from '@polestar/component-warehouse-react/tokens/opacities/Opacities';
const BannerTheme = {
    banner: {
        light: {
            variants: {
                default: {
                    background: Colors.lightGrey,
                    color: Colors.black,
                    iconColor: Colors.black,
                },
                border: {
                    borderColor: withOpacity(Colors.black, Opacities.xLow),
                    background: Colors.transparent,
                    color: Colors.black,
                    iconColor: Colors.black,
                },
            },
        },
        dark: {
            variants: {
                default: {
                    background: withOpacity(Colors.ironGrey, Opacities.low),
                    color: Colors.white,
                    iconColor: Colors.white,
                },
                border: {
                    borderColor: withOpacity(Colors.white, Opacities.low),
                    background: Colors.transparent,
                    color: Colors.white,
                    iconColor: Colors.white,
                },
            },
        },
    },
};
export default BannerTheme;
